import axios from '@_system/axios/axios.js'
export default {
	path: '/supplieraccounts',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
}